export const solarEndpoints = {
    internalRepository: {
        list: {
            api: '/api/solar/partner/content-indentifier/details/list',
            method: 'GET',
            parameter: true
        },
        createMaterial: {
            api: '/api/solar/partner/content-identifier/propagate/create',
            method: 'POST',
            parameter: false
        },
        deleteMasterIR: {
            api: '/api/solar/partner/course-material/delete ',
            method: 'POST',
            parameter: false
        },
        deleteMaterial: {
            api: '/api/solar/partner/content-identifier/soft/delete',
            method: 'POST',
            parameter: true
        },
        listCoursesMaterialIsIncluded: {
            api: '/api/solar/partner/content-identifier/list/courses',
            method: 'GET',
            parameter: true
        },
        listInternalRepositoryVariants: {
            api: '/api/solar/partner/course-material/variants',
            method: 'GET',
            parameter: true
        },
        addInternalRepositoryVariant: {
            api: '/api/solar/partner/course-material/variants/add',
            method: 'POST',
            parameter: false
        },
        editInternalRepositoryVariant: {
            api: '/api/solar/partner/course-material/variants/edit',
            method: 'POST',
            parameter: false
        },
        materialDetails: {
            api: '/api/solar/partner/content-identifier/rich/details',
            method: 'GET',
            parameter: true
        },
        categoryDictionary: {
            api: '/api/solar/partner/category/dictionary ',
            method: 'GET',
            parameter: true
        }
    },
    precourse: {
        updateDetails: {
            api: '/api/solar/precourse/details/update',
            method: 'POST',
            parameter: true
        },
        listByState: {
            api: '/api/solar/precourse/listby',
            method: 'GET',
            parameter: true
        },
        listByStatePlatform: {
            api: '/api/solar/precourse/platform/listby',
            method: 'GET',
            parameter: true
        },
        read: {
            api: '/api/solar/precourse/read',
            method: 'GET',
            parameter: true
        },
        readPlatform: {
            api: '/api/solar/precourse/platform/read',
            method: 'GET',
            parameter: true
        },
        edit: {
            api: '/api/solar/precourse/edit/init',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/solar/precourse/delete',
            method: 'POST',
            parameter: false
        },
        reject: {
            api: '/api/solar/precourse/reject',
            method: 'POST',
            parameter: false
        },
        approve: {
            api: '/api/solar/precourse/approve',
            method: 'POST',
            parameter: false
        },
        requestChanges: {
            api: '/api/solar/precourse/requestchanges',
            method: 'POST',
            parameter: false
        },
        updateAgendaWithCsv: {
            api: '/api/solar/precourse/details/update/agenda/upload/csv',
            method: 'POST',
            parameter: false
        }
    },
    deliverableSpecification: {
        byType: {
            api: '/api/solar/deliverable/spec/type',
            method: 'GET',
            parameter: true
        },
        byConfigId: {
            api: '/api/solar/deliverable/spec/configid',
            method: 'GET',
            parameter: true
        }
    },
    configuration: {
        dictionaryByType: {
            api: '/api/solar/configuration/query/dictionary',
            method: 'GET',
            parameter: false
        },
        dictionaryOfTypes: {
            api: '/api/solar/partner/internal-repository',
            method: 'GET',
            parameter: false
        },
        popularLanguages: {
            api: '/api/solar/partner/configuration/dictionary/popular-languages',
            method: 'GET',
            parameter: false
        },
        otherLanguages: {
            api: '/api/solar/partner/configuration/dictionary/other-languages',
            method: 'GET',
            parameter: false
        }
    },
    course: {
        list: {
            api: '/api/solar/course/list',
            method: 'GET',
            parameter: false
        },
        create: {
            api: '/api/solar/course/create',
            method: 'POST',
            parameter: false
        },
        read: {
            api: '/api/solar/course/read',
            method: 'GET',
            parameter: true
        },
        delete: {
            api: '/api/solar/course/delete',
            method: 'POST',
            parameter: false
        },
        details: {
            api: '/api/solar/course/details',
            method: 'GET',
            parameter: true
        },
        listbystate: {
            api: '/api/solar/course/list/bystate',
            method: 'GET',
            parameter: false
        },
        dictionaryByType: {
            api: '/api/solar/course/dictionary',
            method: 'GET',
            parameter: true
        },
        listRoot: {
            api: '/api/solar/root/course/dictionary',
            method: 'GET',
            parameter: true
        },
        editAttribute: {
            api: '/api/solar/course/edit/attribute',
            method: 'GET',
            parameter: true
        },
        enabledCount: {
            api: '/api/solar/partner/course/enabled/count',
            method: 'GET',
            parameter: false
        },
        thumbnail: {
            generate: {
                api: '/api/solar/course/thumbnail/generate',
                method: 'POST',
                parameter: false
            },
            upload: {
                api: '/api/solar/course/thumbnail/upload',
                method: 'POST',
                parameter: false
            }
        },
        listDraftEvents: {
            api: '/api/solar/partner/course-event/parent/course/draft/list',
            method: 'GET',
            parameter: true
        },
        courseCategoriesByCertificate: {
            api: '/api/solar/partner/category/dictionary/by-certificate',
            method: 'GET',
            parameter: true
        },
        linkedCourses: {
            api: '/api/solar/certificates/used-in/courses',
            method: 'GET',
            parameter: true
        },
        productCategoriesByCertificate: {
            api: '/api/solar/productvariant/category/dictionary/by-certificate',
            method: 'GET',
            parameter: true
        },
        linkedProducts: {
            api: '/api/solar/certificates/used-in/products',
            method: 'GET',
            parameter: true
        }
    },
    courseEvent: {
        waitingList: {
            disable: {
                api: '/api/solar/partner/course-event/waiting-list/disable',
                method: 'POST',
                parameter: true
            },
            enable: {
                api: '/api/solar/partner/course-event/waiting-list/enable',
                method: 'POST',
                parameter: true
            },
            promoteLearner: {
                api: '/api/solar/partner/course-event/learners/waiting/promote',
                method: 'POST',
                parameter: true
            },
            demoteLearner: {
                api: '/api/solar/partner/course-event/learners/waiting/demote',
                method: 'POST',
                parameter: true
            },
            removeLearner: {
                api: '/api/solar/partner/course-event/learners/waiting/remove',
                method: 'POST',
                parameter: true
            }
        },
        attendance: {
            api: '/api/solar/course-event/learners/attendance',
            method: 'POST',
            parameter: true
        },
        attendanceByAgenda: {
            api: '/api/solar/partner/course-event/learners/attendance/details',
            method: 'GET',
            parameter: true
        },
        attendanceChangeForLearner: {
            api: '/api/solar/partner/course-event/learners/attendance/details',
            method: 'POST',
            parameter: true
        },
        cancel: {
            api: '/api/solar/course-event/cancel',
            method: 'POST',
            parameter: true
        },
        cancelEvent: {
            api: '/api/solar/course-event/internal/cancel',
            method: 'POST',
            parameter: true
        },
        instructor: {
            list: {
                api: '/api/solar/instructor/list',
                method: 'GET',
                parameter: false
            },
            createOrUpdate: {
                api: '/api/solar/instructor/add',
                method: 'POST',
                parameter: false
            }
        },
        exams: {
            list: {
                api: '/api/solar/partner/course-event/assessments/list',
                method: 'GET',
                parameter: true
            },
        },
        materialTrack: {
            api: '/api/solar/partner/course-event/completion/report',
            method: 'GET',
            parameter: true
        },
        create: {
            api: '/api/solar/course-event/create',
            method: 'POST',
            parameter: false
        },
        getById: {
            api: '/api/solar/course-event/read',
            method: 'GET',
            parameter: true
        },
        getConferencingDict: {
            api: '/api/solar/partner/authorization/dictionary',
            method: 'GET',
            parameter: false
        },
        saveTokenZoom: {
            api: '/api/solar/partner/authorize/zoom',
            method: 'POST',
            parameter: false
        },
        checkIfUserInAccount: {
            api: '/api/solar/partner/external-meetings/user/exists',
            method: 'GET',
            parameter: true
        },
        checkIfAccountIsPro:{
            api: '/api/solar/partner/external-meetings/account/is-pro',
            method: 'GET',
            parameter: true
        },
        update: {
            api: '/api/solar/course-event/details/update',
            method: 'POST',
            parameter: true
        },
        list: {
            api: '/api/solar/course-event/list',
            method: 'GET',
            parameter: false
        },
        listLite: {
            api: '/api/solar/course-event/list/lite',
            method: 'GET',
            parameter: false
        },
        listByCourseId: {
            api: '/api/solar/partner/course-event/parent/list',
            method: 'GET',
            parameter: true
        },
        listByInstructorOnDate: {
            api: '/api/solar/partner/course-event/instructor/collision',
            method: 'GET',
            parameter: true
        },
        listByInstructorsOnDate: {
            api: '/api/solar/partner/course-event/instructors/collision',
            method: 'POST',
            parameter: false
        },
        editAttribute: {
            api: '/api/solar/course-event/edit/attribute',
            method: 'POST',
            parameter: true
        },
        deliveryLanguagesDict: {
            api: '/api/solar/partner/configuration/dictionary/delivery-languages',
            method: 'GET',
            parameter: false
        },
        learner: {
            list: {
                api: '/api/solar/classevent/learners/status',
                method: 'GET',
                parameter: true
            },
            approval: {
                approve: {
                    api: '/api/solar/course-event/learners/approve',
                    method: 'POST',
                    parameter: false
                },
                reject: {
                    api: '/api/solar/course-event/learners/reject',
                    method: 'POST',
                    parameter: false
                },
            },
            add: {
                api: '/api/solar/course-event/learners/add',
                method: 'POST',
                parameter: true
            },
            remove: {
                api: '/api/solar/course-event/learners/remove',
                method: 'POST',
                parameter: true
            },
            bulkImport: {
                api: '/api/solar/course-event/learners/bulk-import',
                method: 'POST',
                parameter: true
            },
            csvUpload: {
                validation: {
                    api: '/api/solar/partner/course-event/upload/learner/csv/validate',
                    method: 'POST',
                    parameter: true
                },
                upload: {
                    api: '/api/solar/partner/course-event/upload/learner/csv',
                    method: 'POST',
                    parameter: true
                }
            }
        },
        bulkAttendance: {
            api: '/api/solar/partner/course-event/learners/attendance/bulk',
            method: 'POST',
            parameter: true
        },
        unmarkAttendance: {
            api: '/api/solar/partner/course-event/learners/unmark/attendance',
            method: 'POST',
            parameter: true
        },
        validateCompletion: {
            api: '/api/solar/partner/course-event/learners/attendance/validate-before-completion',
            method: 'POST',
            parameter: true
        },
        validateSessionAccess: {
            api: '/api/solar/partner/course-event/join/validate',
            method: 'GET',
            parameter: true
        },
        seatCancellationPolicies: {
            api: '/api/solar/course-event/seat-cancellation-policies',
            method: 'GET',
            parameter: false
        },
        promotionsDictionary: {
            api: '/api/solar/course-event/promotions/dictionary',
            method: 'GET',
            parameter: true
        },
    },
    review: {
        list: {
            api: '/api/solar/review/list',
            method: 'GET',
            parameter: true
        },
        delete: {
            api: '/api/solar/review/delete',
            method: 'POST',
            parameter: false
        },
        moderate: {
            api: '/api/solar/review/moderate',
            method: 'POST',
            parameter: false
        }
    },
    user: {
        list: {
            api: '/api/solar/partner/user',
            method: 'GET',
            parameter: false
        },
        edit: {
            api: '/api/solar/partner/user/edit',
            method: 'POST',
            parameter: true
        },

        brandedPortalUrl: {
            api: '/api/solar/partner/domain/me/brandedportalurl',
            method: 'GET',
            parameter: false
        }
    },
    domain: {
        list: {
            api: '/api/solar/domain',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/solar/domain/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/solar/domain/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/solar/domain/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/solar/domain/delete',
            method: 'POST',
            parameter: false
        },
        brandedUrl: {
            api: '/api/solar/partner/domain/me/brandedportalurl',
            method: 'GET',
            parameter: false
        },
        dictionary: {
            api: '/api/solar/platform/domain/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    domainname: {
        add: {
            api: '/api/solar/domain/name/add',
            method: 'POST',
            parameter: false
        },
        makedefault: {
            api: '/api/solar/domain/name/makedefault',
            method: 'POST',
            parameter: false
        }
    },
    learner: {
        list: {
            api: '/api/solar/learner',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/solar/learner/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/solar/learner/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/solar/learner/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/solar/learner/delete',
            method: 'POST',
            parameter: false
        }
    },
    instructor: {
        list: {
            api: '/api/solar/instructor',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/solar/instructor/details',
            method: 'GET',
            parameter: true
        },
        email: {
            api: '/api/solar/user/byusername',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/solar/user/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/solar/instructor/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/solar/instructor/delete',
            method: 'POST',
            parameter: false
        },
        accredited: {
            api: '/api/solar/user/instructor/accredited',
            method: 'GET',
            parameter: false
        },
        toggleUser: {
            api: '/api/solar/user/instructor/togglePreference',
            method: 'POST',
            parameter: true
        },
        promote: {
            api: '/api/solar/user/promote',
            method: 'POST',
            parameter: true
        },
        preference: {
            api: '/api/solar/user/setPreference'
        }
    },
    license: {
        voucherDetails: {
            api: '/api/solar/partner/license/voucher/details',
            method: 'GET',
            parameter: true
        },
        editExamVoucherAccess: {
            api: '/api/solar/partner/license/voucher/assessment/edit',
            method: 'POST',
            parameter: false
        },
        consumptionProduct: {
            add: {
                api: '/api/voucher/v2/consumption/mapping/add ',
                method: 'POST',
                parameter: true
            },
            addNew: {
                api: '/api/solar/partner/consumption/add/product',
                method: 'POST',
                parameter: true
            },
            assign: {
                api: '/api/solar/partner/license/assign/consumption/product',
                method: 'POST',
                parameter: true
            },
            assignExam: {
                api: '/api/solar/partner/license/assign/consumption/exam',
                method: 'POST',
                parameter: true
            }

        },
        details: {
            api: '/api/solar/license/details',
            method: 'GET',
            parameter: true
        },
        list: {
            all: {
                api: '/api/solar/assignment',
                method: 'GET',
                parameter: true
            },
            summary: {
                api: '/api/solar/license/summary',
                method: 'GET',
                parameter: false
            },
            consumption: {
                summary: {
                    api: '/api/solar/license/consumption/summary',
                    method: 'GET',
                    parameter: false
                }
            },
            delivery: {
                summary: {
                    api: '/api/solar/license/delivery/summary',
                    method: 'GET',
                    parameter: false
                }
            }
        },
        assign: {
            bulk: {
                api: '/api/solar/license/assign/bulk',
                method: 'POST',
                parameter: false
            },
            product: {
                api: '/api/solar/license/assign/product',
                method: 'POST',
                parameter: false
            },
            voucher: {
                api: '/api/solar/license/assign/voucher',
                method: 'POST',
                parameter: false
            },
            bulkCsvUpload: {
                api: '/api/solar/partner/license/assign/bulk/voucher',
                method: 'POST',
                parameter: false
            }
        },
        unassign: {
            product: {
                api: '/api/solar/license/unassign/product',
                method: 'POST',
                parameter: true
            }
        },
        reserve: {
            product: {
                api: '/api/solar/license/reserve/product',
                method: 'POST',
                parameter: false
            },
            voucher: {
                api: '/api/solar/license/reserve/voucher',
                method: 'POST',
                parameter: false
            }
        },
        unreserve: {
            product: {
                api: '/api/solar/license/unreserve/product',
                method: 'POST',
                parameter: true
            }
        },
        return: {
            voucher: {
                api: '/api/solar/license/return/voucher',
                method: 'POST',
                parameter: false
            }
        },
        externalReferences: {
            api: '/api/solar/license/voucher-references',
            method: 'GET',
            parameter: false
        }
    },
    templates: {
        bulkDelete: {
            api: '/api/solar/templates/bulk/delete',
            method: 'POST',
            parameter: true
        },
        list: {
            api: '/api/solar/templates/list',
            method: 'POST',
            parameter: true
        }
    },
    classevent: {
        add: {
            api: '/api/solar/classevent/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/solar/classevent/edit',
            method: 'POST',
            parameter: false
        },
        list: {
            api: '/api/solar/classevent/list',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/solar/classevent/details',
            method: 'GET',
            parameter: true
        },
        delete: {
            api: '/api/solar/classevent/delete',
            method: 'POST',
            parameter: false
        },
        release: {
            api: '/api/solar/classevent/release',
            method: 'POST',
            parameter: true
        },
        products: {
            patch: {
                api: '/api/solar/classevent/patch/productvariants',
                method: 'POST',
                parameter: true
            }
        },
        instructor: {
            patch: {
                api: '/api/solar/classevent/patch/instructors',
                method: 'POST',
                parameter: true
            }
        },
        learner: {
            list: {
                api: '/api/solar/classevent/partial/learner',
                method: 'GET',
                parameter: true
            },
            patch: {
                add: {
                    api: '/api/solar/classevent/patch/learners/add',
                    method: 'POST',
                    parameter: true
                },
                edit: {
                    api: '/api/solar/classevent/patch/learners/edit',
                    method: 'POST',
                    parameter: true
                },
                remove: {
                    api: '/api/solar/classevent/patch/learners/remove',
                    method: 'POST',
                    parameter: true
                }
            }
        },
        voucher: {
            list: {
                api: '/api/solar/classevent/partial/license',
                method: 'GET',
                parameter: true
            }
        },
        assignment: {
            assign: {
                api: '/api/solar/classevent/patch/assign',
                method: 'POST',
                parameter: true
            },
            unassign: {
                api: '/api/solar/classevent/patch/unassign',
                method: 'POST',
                parameter: true
            },
            list: {
                api: '/api/solar/classevent/partial/assignment',
                method: 'GET',
                parameter: true
            }
        },
        exam: {
            patch: {
                api: '/api/solar/classevent/patch/exams',
                method: 'POST',
                parameter: true
            }
        },
        email: {
            preview: {
                api: '/api/solar/classevent/email/preview',
                method: 'GET',
                parameter: true
            },
            previewCustomTemplate: {
                api: '/api/solar/classevent/email/preview/custom',
                method: 'GET',
                parameter: true
            },
            customMessage: {
                learner: {
                    api: '/api/solar/classevent/patch/customlearnermessage',
                    method: 'POST',
                    parameter: true
                },
                instructor: {
                    api: '/api/solar/classevent/patch/custominstructormessage',
                    method: 'POST',
                    parameter: true
                },
                certificate: {
                    api: '/api/solar/classevent/patch/customcertificatemessage',
                    method: 'POST',
                    parameter: true
                }
            },
            template: {
                delete: {
                    api: '/api/solar/classevent/templates/delete',
                    method: 'POST',
                    parameter: false
                },
                select: {
                    api: '/api/solar/classevent/templates/selected',
                    method: 'POST',
                    parameter: false
                },
                selected: {
                    api: '/api/solar/classevent/templates/selected',
                    method: 'GET',
                    parameter: false
                },
                byType: {
                    api: '/api/solar/classevent/templates',
                    method: 'GET',
                    parameter: false
                },
                global: {
                    api: '/api/solar/classevent/templates/global',
                    method: 'POST',
                    parameter: false
                }
            }
        },
        certificate: {
            preview: {
                api: '/api/solar/classevent/certificate/preview',
                method: 'POST',
                parameter: false
            },
            download: {
                api: '/api/solar/classevent/certificate/download',
                method: 'POST',
                parameter: false
            },
            listTemplates: {
                api: '/api/solar/classevent/templates',
                method: 'GET',
                parameter: false
            },
            emailPreview: {
                api: '/api/emails/preview',
                method: 'POST',
                parameter: false
            },
            send: {
                api: '/api/solar/classevent/certificate/send',
                method: 'POST',
                parameter: false
            },
            learner: {
                schedule: {
                    api: '/api/solar/classevent/certificate/learner/schedule',
                    method: 'POST',
                    parameter: false
                }
            },
            certificatesIssued: {
                api: '/api/solar/certificates/list/issued',
                method: 'GET',
                parameter: false
            },
            certificateNameCheck: {
                api:'/api/solar/partner/certificates/name-check',
                method : 'GET',
                parameter: false
            }
        },
        address: {//
            patch: {
                api: '/api/solar/classevent/patch/address',
                method: 'POST',
                parameter: true
            },
            usesInClass: {
                api: '/api/solar/classevent/patch/address/count',
                method: 'GET',
                parameter: true
            },
            list: {
                api: '/api/solar/classevent/patch/address/list',
                method: 'GET',
                parameter: true
            },
        },
        dictionary: {
            api: '/api/solar/classevent/dictionary',
            method: 'GET',
            parameter: true
        },
        newWorkFlow: {
            add: {
                api: '/api/solar/class-event/new-workflow',
                method: 'POST',
                parameter: true
            },
            drafts: {
                create: {
                    api: '/api/solar/class-event/new-workflow/drafts',
                    method: 'POST',
                    parameter: true
                },
                load: {
                    api: '/api/solar/class-event/new-workflow/drafts',
                    method: 'GET',
                    parameter: true
                },
                list: {
                    api: '/api/solar/class-event/new-workflow/list-drafts',
                    method: 'GET',
                    parameter: true
                },
                bulkDelete: {
                    api: '/api/solar/class-event/new-workflow/drafts/bulk/delete',
                    method: 'POST',
                    parameter: true
                }
            }
        }
    },
    exams: {
        list: {
            api: '/api/solar/exams/list',
            method: 'GET',
            parameter: false
        },
        address: {
            patch: {
                api: '/api/solar/exam/patch/address',
                method: 'POST',
                parameter: true
            }
        },
        add: {
            api: '/api/solar/examsession/add',
            method: 'POST',
            parameter: false

        }
    },
    address: {
        add: {
            api: '/api/solar/address/add',
            method: 'POST',
            parameter: false
        },
        editall: {
            api: '/api/solar/address/editall',
            method: 'POST',
            parameter: true
        },
        dictionary: {
            api: '/api/solar/address/dictionary',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/solar/address/details',
            method: 'GET',
            parameter: true
        },
        list: {
            api: '/api/solar/address',
            method: 'GET',
            parameter: false
        },
        listroot: {
            api: '/api/solar/address/root',
            method: 'GET',
            parameter: false
        },
        bulkDelete: {
            api: '/api/solar/address/bulk/delete',
            method: 'POST',
            parameter: true
        },
        simpleDictionary: {
            api: '/api/solar/address/simple/dictionary?$name=1',
            method: 'GET',
            parameter: false
        },
        listVenuesByCity: {
            api: '/api/solar/address/filterable',
            method: 'GET',
            parameter: true
        },
        countryDictionary: {
            api: '/api/solar/address/country/dictionary',
            method: 'GET',
            parameter: true
        },
        cityDictionary: {
            api: '/api/solar/address/city/dictionary',
            method: 'GET',
            parameter: true
        }
    },
    contact: {
        add: {
            api: '/api/solar/contactperson/add',
            method: 'POST',
            parameter: false
        },
        dictionary: {
            api: '/api/solar/contactperson/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    company: {
        add: {
            api: '/api/solar/company/add',
            method: 'POST',
            parameter: false
        },
        dictionary: {
            api: '/api/solar/company/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    productVariant: {
        details: {
            sku: {
                api: '/api/solar/productvariant/details/sku',
                method: 'GET',
                parameter: true
            },
            bulkSkus: {
                api: '/api/solar/productvariant/details/bulk/sku?sku=',
                method: 'GET',
                parameter: true
            },
            dictionary: {
                api: '/api/solar/productvariant/dictionary',
                method: 'GET',
                parameter: true
            }
        },
        activate: {
            api: '/api/solar/productvariant/bulk/activate',
            method: 'POST',
            parameter: true
        }
    },
    product: {
        productGroup: {
            api: '/api/solar/productgroup/available',
            method: 'GET',
            parameter: false
        },
        product: {
            api: '/api/solar/productgroup/product/courseware/available',
            method: 'GET',
            parameter: true
        },
        productVariant: {
            api: '/api/solar/product/variant/available',
            method: 'GET',
            parameter: true
        },
        allVariants: {
            api: '/api/solar/productvariant/courseware/list/availability',
            method: 'GET',
            parameter: false
        },
        availableByGroup: {
            api: '/api/solar/product/variant/available/group',
            method: 'GET',
            parameter: false
        },
        variant: {
            available: {
                list: {
                    api: '/api/solar/product/variant/available/list',
                    method: 'GET',
                    parameter: true
                }
            }
        },
    },
    productGroup: {
        available: {
            api: '/api/solar/productgroup/product/available',
            method: 'GET',
            parameter: false
        }
    },
    timezone: {
        dictionary: {
            api: '/api/solar/system/datetime/timezones',
            method: 'GET',
            parameter: false
        }
    },
    language: {
        dictionary: {
            api: '/api/solar/system/language',
            method: 'GET',
            parameter: false
        }
    },
    exam: {
        fulfillment: {
            start: {
                api: '/api/solar/exam/fulfillment/start',
                method: 'POST',
                parameter: true
            },
            complete: {
                api: '/api/solar/exam/fulfillment/complete',
                method: 'POST',
                parameter: true
            },
            learner: {
                api: '/api/solar/exam/fulfillment/patch/learner',
                method: 'POST',
                parameter: true
            },
            patch: {
                api: '/api/solar/exam/fulfillment/patch/exam',
                method: 'POST',
                parameter: true
            },
            seller: {
                api: '/api/solar/exam/fulfillment/seller',
                method: 'GET',
                parameter: false
            },
            platform: {
                api: '/api/solar/exam/fulfillment/leapest',
                method: 'GET',
                parameter: false
            },
            list: {
                api: '/api/solar/exam/fulfillment',
                method: 'GET',
                parameter: false
            },
            bulkFulfill: {
                api: '/api/solar/platform/bulk/edit/learner/fulfill/exam',
                method: 'POST',
                parameter: true
            },
            details: {
                api: '/api/solar/exam/fulfillment/details',
                method: 'GET',
                parameter: true
            },
            receivers: {
                api: '/api/solar/exam/fulfillment/patch/receivers',
                method: 'POST',
                parameter: true
            },
            learners: {
                api: '/api/exam/fulfillment/partial/list',
                method: 'GET',
                parameter: true
            },
            fulfillGeneral: {
                api: '/api/exam/fulfillment/partial/patch',
                method: 'POST',
                parameter: true
            },
            results: {
                api: '/api/exam/fulfillment/scores',
                method: 'POST',
                parameter: true
            },
            certificates: {
                issue: {
                    api: '/api/exam/fulfillment/certificates',
                    method: 'POST',
                    parameter: true
                }
            }
        },
        learners: {
            list: {
                api: '/api/solar/exam/fulfillment/learners',
                method: 'GET',
                parameter: true
            }
        }
    },
    deliverable: {
        content: {
            api: '/api/solar/deliverable/content/proxy',
            method: 'GET',
            parameter: true
        }
    },
    zephyr: {
        registrations: {
            clean: {
                api: '/api/zephyr/registrations/delete-bulk',
                method: 'POST',
                parameter: false
            },
            list: {
                api: '/api/zephyr/registrations',
                method: 'GET',
                parameter: false
            }
        },
        assessment: {
            bulkRead: {
                api: '/api/zephyr/assessment/read-bulk',
                method: 'GET',
                parameter: true
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/solar.endpoints.ts